"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YellowPageSearchMapper = void 0;
var YellowPageSearchMapper = /** @class */ (function () {
    function YellowPageSearchMapper(data) {
        this.localData = data;
    }
    YellowPageSearchMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return YellowPageSearchMapper;
}());
exports.YellowPageSearchMapper = YellowPageSearchMapper;
//# sourceMappingURL=YellowPageSearchMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/YellowPageSearchMapper.js
// module id = 2068
// module chunks = 8